import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="confirmations"
export default class extends Controller {
  static targets = ["lastName", "firstName", "staffName", "promoterName", "sellerInfoName"];

  updateStaffName() {
    const lastName = this.lastNameTarget.value;
    const firstName = this.firstNameTarget.value;
    this.staffNameTarget.textContent = `${lastName} ${firstName}`;
  }

  updatePromoterName() {
    const promoterName = this.promoterNameTarget.value;
    this.sellerInfoNameTarget.value = `${promoterName}`;
  }
}
